import { ASIN_REGEX } from 'src/constants/regexConstants';

export const InputAsinsValidationUtils = (asinList: string[]) => {
  for (let i = 0; i < asinList.length; i += 1) {
    const asin = asinList[i];
    if (!ASIN_REGEX.test(asin)) {
      return false;
    }
  }
  return true;
};

export const getAsinValidationMessage = (listOfAsins: string[]) => {
  if (listOfAsins.filter((asin) => asin.trim().length > 0).length === 0) {
    return false;
  }
  return !InputAsinsValidationUtils(listOfAsins);
};
